import {
  Editor,
  Transforms
} from 'slate';

import elementTypes from '../../elements/types';
import HelptapEditor from '../';

export function getDefaultOptions(options) {

  const node = {
    children: [{ text: '' }],
    padding: [0, 0, 0, 0],
    margin: [0, 0, 0, 0],
    ...options,
    type: elementTypes.SINGLE_PRODUCER_MEETING
  };

  return node;

}

function select(editor, path) {

  Transforms.select(editor, path);

}

function doInsert(editor, options, path) {

  const node = getDefaultOptions(options);

  Transforms.insertNodes(editor, node, {
    at: path
  });

  select(editor, path);

}

export function insert(editor, options, editorOptions, targetNodePath, nextNodePath) {

  Editor.withoutNormalizing(editor, () => {

    doInsert(editor, options, nextNodePath);

  });

}

export function toggle(editor, options, editorOptions, targetNodePath, nextNodePath) {

  Editor.withoutNormalizing(editor, () => {

    doInsert(editor, options, targetNodePath);
    Transforms.removeNodes(editor, { at: nextNodePath });

  });

}

export function cloneNode(node) {

  const clonedNode = HelptapEditor.cloneNode(node);

  return clonedNode;

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = cloneNode(node);

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}